import { useQuery } from 'react-query'
import axios from 'axios'
import { API_URL } from '../../config'
import { rqDefaultOptions } from './defaultOptions'

const getAllPurchaseOrders = async (inputObj) => {
  const { limit, skip, email } = inputObj.queryKey[1]
  axios.defaults.headers.common['Authorization'] = email
  const allPurchaseOrdersAPIPath = `${API_URL}/api/purchaseOrder/v1/getAllPurchaseOrders?limit=${limit}&skip=${skip}`
  const res = await axios.get(allPurchaseOrdersAPIPath)
  return res.data
}

export function useAllPurchaseOrders(queryKey, limit = 20, skip = 0, email) {
  const options = {
    ...rqDefaultOptions,
  }
  return useQuery([queryKey, { limit, skip, email }], getAllPurchaseOrders, options)
}
